import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import './Article.scss'

const ArticleCard = ({image, title, created_at, slug}) => {
    return (
        <Link to={`/artigos/${slug}`} className="article-card">
            <div>
                <figure>
                    <img src={image} alt={title}/>
                </figure>
            </div>
            <h6>{title}</h6>
            <span className="date">{moment(created_at).format('DD/MM/YYYY')}</span>
        </Link>
    )
}

export default ArticleCard


// WEBPACK FOOTER //
// ./src/components/Card/Article.js